import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_TENURE = 0;
const DEFAULT_MAX_TENURE = 2;

export const tenureDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.TENURE,
  name: 'Tenure',
  type: FilterType.RANGE,
  min: DEFAULT_MIN_TENURE,
  max: DEFAULT_MAX_TENURE,
  isActive: false,
  isVisible: true,
};

export const tenureHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    // Only apply defaults if BOTH min and max are undefined
    // If only one is undefined, keep it undefined (for "greater than" / "less than" filters)
    const shouldApplyDefaults =
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined;

    if (shouldApplyDefaults) {
      return {
        ...currentFilterState,
        min: DEFAULT_MIN_TENURE,
        max: DEFAULT_MAX_TENURE,
      };
    }

    // Preserve the user's selection - don't fill in undefined values
    return currentFilterState;
  },
};
